import { render, staticRenderFns } from "./AppPushNotification.vue?vue&type=template&id=4a8343a8&scoped=true"
import script from "./AppPushNotification.vue?vue&type=script&lang=js"
export * from "./AppPushNotification.vue?vue&type=script&lang=js"
import style0 from "./AppPushNotification.vue?vue&type=style&index=0&id=4a8343a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8343a8",
  null
  
)

export default component.exports